module.exports = "<div class=form-field> <div ng-if=!$ctrl.hideLabel ng-class=[$ctrl.labelClass] class=form-field-label> {{ $ctrl.label }} </div> <div ng-class=[$ctrl.inputClass] class=form-field-input> <toggle ng-model=$ctrl.isChecked class=circle-toggle off=\"\" on=\"\"> </toggle> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/form-fields/checkbox-field/checkbox-field.html
// module id = 341
// module chunks = 0